import CreateTabs from "common/components/createTabs";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { useState } from "react";
import { Box, Button, Input, Textarea } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { crmConstant } from "services/Crm/constant";
import { globalStyles } from "common/theme/styles";
import { constant } from "common/constant";
import {
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Image,
  InputGroup,
  InputRightElement,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { postApi } from "common/services/api";
import { PasswordSchema } from "services/Vault/schema/PasswordSchema";
import { toast } from "react-toastify";
import { vaultConstant } from "services/Vault/constant";
import ShowIcon from "common/assets/img/ShowIcon.png";
import HideIcon from "common/assets/img/HideIcon.png";
import CopyIcon from "common/assets/img/Copy.png";
import { HandleCopy } from "common/utils/handleCopy";

const PasswordInformation = (props) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const colors = globalStyles.colors;
  const [urlRequired, setUrlRequired] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const initialValues = {
    username: "",
    password: "",
    confirmPassword: "",
    provider: "",
    type: "",
    url: "",
    notes: "",
    permission: "permission",
  };
  const formik = useFormik({
    initialValues: initialValues,
    // validationSchema: PasswordSchema,
    validationSchema: PasswordSchema(urlRequired),
    onSubmit: (values, { resetForm }) => {
      AddData(resetForm);
    },
  });
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;
  function onChangHeandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    handleChange(e);

    if (e.target.name === "type") {
      setUrlRequired(e.target.value === "site");
    }
  }

  const AddData = async (resetForm) => {
    try {
      setIsLoading(true);
      const payload = {
        username: values.username.trim(),
        password: values.password.trim(),
        confirmPassword: values.confirmPassword.trim(),
        provider: values.provider.trim(),
        type: values.type,
        url: values.url.trim(),
        notes: values.notes.trim(),
        permission: values.permission,
      };
      let response = await postApi("api/password/create-password", payload);
      if (response.status === 201) {
        toast.success("Password saved successfully");
        navigate(-1);
        // props.setAction((pre) => !pre);
      } else {
        toast.error("Something went wrong");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      resetForm();
      setIsLoading(false);
    }
  };

  const handleBackPage = () => {
    navigate(-1);
  };
  return (
    <>
      <Box className="commonPanelBody">
        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              Provider Name<Text color={colors.error["100"]}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              value={values.provider}
              name="provider"
              placeholder={vaultConstant.providerLabel}
              fontWeight="500"
              onChange={(e) => {
                onChangHeandler(e);
              }}
              onBlur={handleBlur}
              borderColor={
                errors.provider && touched.provider ? colors.error["100"] : null
              }
            />
            <Text mb="10px" fontSize={"14px"} color={colors.error["100"]}>
              {" "}
              {errors.provider && touched.provider && errors.provider}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.userName}
              <Text color={colors.error["100"]}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              value={values.username}
              name="username"
              autoComplete="off"
              onBlur={handleBlur}
              placeholder={constant.enterUserName}
              fontWeight="500"
              onChange={(e) => {
                onChangHeandler(e);
              }}
              borderColor={
                errors.username && touched.username ? colors.error["100"] : null
              }
            />
            <Text mb="10px" fontSize={"14px"} color={colors.error["100"]}>
              {" "}
              {errors.username && touched.username && errors.username}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.password}
              <Text color={colors.error["100"]}>*</Text>
            </FormLabel>
            <InputGroup className="iconGroup">
              <Input
                fontSize="sm"
                onBlur={handleBlur}
                value={values.password}
                name="password"
                placeholder={constant.enterPassword}
                fontWeight="500"
                autoComplete="new-password"
                onChange={(e) => {
                  onChangHeandler(e);
                }}
                type={showPassword ? "text" : "password"}
                borderColor={
                  errors.password && touched.password
                    ? colors.error["100"]
                    : null
                }
              />
              <InputRightElement right={"24px"} display="flex" gap={1}>
                <IconButton
                  aria-label="Toggle Password Visibility"
                  icon={
                    !showPassword ? (
                      <Image alt="hideicon" h="20px" w="20px" src={HideIcon} />
                    ) : (
                      <Image alt="showicon" h="20px" w="20px" src={ShowIcon} />
                    )
                  }
                  size="sm"
                  onClick={() => setShowPassword(!showPassword)}
                  variant="ghost"
                />
                <IconButton
                  aria-label="Copy Password"
                  icon={<Image h="20px" w="20px" alt="copy" src={CopyIcon} />}
                  size="sm"
                  onClick={() => {
                    HandleCopy(values?.password);
                  }}
                  variant="ghost"
                />
              </InputRightElement>
            </InputGroup>

            <Text mb="10px" fontSize="14px" color={colors.error["100"]}>
              {errors.password && touched.password && errors.password}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.confirmPassword}
              <Text color={colors.error["100"]}>*</Text>
            </FormLabel>
            <InputGroup className="iconGroup">
              <Input
                fontSize="sm"
                onBlur={handleBlur}
                autoComplete="new-password"
                value={values.confirmPassword}
                name="confirmPassword"
                placeholder={constant.confirmPassword}
                fontWeight="500"
                onChange={(e) => {
                  onChangHeandler(e);
                }}
                type={showConfirmPassword ? "text" : "password"}
                borderColor={
                  errors.confirmPassword && touched.confirmPassword
                    ? colors.error["100"]
                    : null
                }
              />
              <InputRightElement right={"24px"} display="flex" gap={1}>
                <IconButton
                  aria-label="Toggle Password Visibility"
                  icon={
                    !showConfirmPassword ? (
                      <Image alt="hideicon" h="20px" w="20px" src={HideIcon} />
                    ) : (
                      <Image alt="showicon" h="20px" w="20px" src={ShowIcon} />
                    )
                  }
                  size="sm"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  variant="ghost"
                />
                <IconButton
                  aria-label="Copy Password"
                  icon={<Image h="20px" w="20px" alt="copy" src={CopyIcon} />}
                  size="sm"
                  onClick={() => {
                    HandleCopy(values?.confirmPassword);
                  }}
                  variant="ghost"
                />
              </InputRightElement>
            </InputGroup>

            <Text mb="10px" fontSize="14px" color={colors.error["100"]}>
              {errors.confirmPassword &&
                touched.confirmPassword &&
                errors.confirmPassword}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {vaultConstant.url}
              {urlRequired && <Text color={colors.error["100"]}>*</Text>}
            </FormLabel>
            <Input
              fontSize="sm"
              onChange={(e) => {
                onChangHeandler(e);
              }}
              onBlur={handleBlur}
              value={values.url}
              name="url"
              placeholder={vaultConstant.urlPlaceholder}
              fontWeight="500"
              borderColor={
                errors?.url && touched?.url ? colors.error["100"] : null
              }
            />
            {urlRequired && (
              <Text mb="10px" fontSize={"14px"} color={colors.error["100"]}>
                {" "}
                {errors.url && touched.url && errors.url}
              </Text>
            )}
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {vaultConstant.type} <Text color={colors.error["100"]}>*</Text>
            </FormLabel>
            <Select
              onBlur={handleBlur}
              value={values.type}
              name="type"
              onChange={(e) => {
                onChangHeandler(e);
              }}
              mb={errors.type && touched.type ? undefined : "10px"}
              fontWeight="500"
              borderColor={
                errors.type && touched.type ? colors.error["100"] : null
              }
              color={values.type ? colors.textColor : colors.placeholder}
            >
              <option className="" value="" disabled hidden>
                {constant.select}
              </option>
              {vaultConstant.passwordType?.map((item) => {
                return (
                  <option value={item.value} key={item.value}>
                    {item.label}
                  </option>
                );
              })}
            </Select>
            <Text mb="10px" fontSize={"14px"} color={colors.error["100"]}>
              {" "}
              {errors.type && touched.type && errors.type}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {vaultConstant.notes} <Text color={colors.error["100"]}>*</Text>
            </FormLabel>
            <Textarea
              resize={"none"}
              fontSize="sm"
              onChange={(e) => {
                onChangHeandler(e);
              }}
              onBlur={handleBlur}
              value={values.notes}
              name="notes"
              placeholder={constant.notes}
              fontWeight="500"
              borderColor={
                errors?.notes && touched?.notes ? colors.error["100"] : null
              }
            />
            <Text mb="10px" fontSize={"14px"} color={colors.error["100"]}>
              {" "}
              {errors.notes && touched.notes && errors.notes}
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button
          variant="brand"
          size="sm"
          disabled={isLoading || !formik.isValid || !formik.dirty}
          onClick={handleSubmit}
          className="theme-btn1"
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {vaultConstant.add}
        </Button>
      </Box>
    </>
  );
};

const CreatePassword = () => {
  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate(-1);
  };

  const tabsData = [{ label: vaultConstant.passwordInformation, Icon: JobOpeningIcon }];

  const panelsData = [<PasswordInformation />];

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={vaultConstant.createPassword}
    />
  );
};

export default CreatePassword;
